export interface FeaturedItem {
  id: string;
  title: string;
  tagline: string;
  meta: string;
  rating: number;
  backdrop: string;
}

export const featured: FeaturedItem[] = [
  {
    id: "mv-01",
    title: "流浪地球3",
    tagline: "人类文明的最后一次点火，四十八小时决定存亡",
    meta: "2025 · 中国大陆 · 科幻 / 灾难",
    rating: 8.7,
    backdrop: "https://readdy.ai/api/search-image?query=epic%20sci-fi%20cinematic%20wide%20shot%20of%20a%20towering%20glowing%20planetary%20engine%20against%20a%20frozen%20dark%20earth%20sky%2C%20vast%20atmospheric%20scale%2C%20dramatic%20lighting%2C%20deep%20contrast%2C%20professional%20film%20key%20visual%2C%20no%20text&width=1600&height=900&seq=hero-mv01&orientation=landscape",
  },
  {
    id: "tv-01",
    title: "长夜将明",
    tagline: "十五年的悬案重启，真相越近，长夜越深",
    meta: "2025 · 中国大陆 · 悬疑 / 犯罪",
    rating: 8.8,
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20noir%20city%20street%20at%20night%20in%20heavy%20rain%20with%20reflected%20streetlights%2C%20moody%20atmosphere%2C%20dramatic%20high%20contrast%20shadows%2C%20professional%20film%20key%20visual%2C%20no%20text&width=1600&height=900&seq=hero-tv01&orientation=landscape",
  },
  {
    id: "mv-08",
    title: "星际信使",
    tagline: "一段来自四光年外的钢琴曲，藏着人类的坐标",
    meta: "2024 · 美国 · 科幻 / 冒险",
    rating: 8.1,
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20space%20scene%20with%20a%20giant%20ringed%20planet%20and%20a%20tiny%20glowing%20spacecraft%2C%20deep%20starfield%2C%20dramatic%20lighting%2C%20rich%20cosmic%20colors%2C%20professional%20film%20key%20visual%2C%20no%20text&width=1600&height=900&seq=hero-mv08&orientation=landscape",
  },
  {
    id: "va-02",
    title: "音乐现场",
    tagline: "一句不修，把最真实的声音还给观众",
    meta: "2025 · 中国大陆 · 音乐 / 竞技",
    rating: 8.6,
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20live%20concert%20stage%20with%20warm%20orange%20spotlights%20and%20audience%20silhouettes%20in%20haze%2C%20dramatic%20lighting%2C%20rich%20warm%20colors%2C%20professional%20key%20visual%2C%20no%20text&width=1600&height=900&seq=hero-va02&orientation=landscape",
  },
  {
    id: "tv-05",
    title: "白露为霜",
    tagline: "一味古方，一场天劫，两个人的宿命相遇",
    meta: "2025 · 中国大陆 · 古装 / 玄幻",
    rating: 7.9,
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20fantasy%20landscape%20with%20misty%20bamboo%20forest%20and%20floating%20white%20petals%2C%20ethereal%20moody%20lighting%2C%20rich%20cinematic%20colors%2C%20professional%20key%20visual%2C%20no%20text&width=1600&height=900&seq=hero-tv05&orientation=landscape",
  },
];

export default featured;